import {
  RACK_SECTION_TYPE,
  TypePartialRackItem,
} from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";
import { findIndexByXY, xyPositionRackItem } from "@utils/xyPositionRackItem";
import { ISection } from "./RackEditComponent/useRackEditComponentControl";

export const checkMinerInDeletedSections = (
  arr: TypePartialRackItem[],
  type: [number, number],
  currentType: [number, number]
): boolean => {
  let hasMiner = false;
  arr.forEach((item, i) => {
    if (item.pos === RACK_SECTION_TYPE.MINER) {
      const [X, Y] = xyPositionRackItem(i, type);
      if (X > currentType[0] || Y > currentType[1]) {
        hasMiner = true;
      }
    }
  });

  return hasMiner;
};

export const compareMinersPositions = (
  minersPositions: ISection[],
  items: ISection[],
  rackType: [number, number]
): ISection[] => {
  const positions = [...minersPositions];
  let compirePositions: ISection[] = items.map((item) => ({
    pos: RACK_SECTION_TYPE.EMPTY,
    x: item.x,
    y: item.y,
  }));

  while (positions.length > 0) {
    const position = positions.shift() as ISection;

    const currIndex = findIndexByXY([position.x, position.y], rackType);
    compirePositions[currIndex] = position;
  }
  return compirePositions;
};
